import React from 'react';

// Shown while a lazily-loaded route chunk downloads. The spinner is a CSS
// transform animation (GPU/compositor), so it keeps spinning smoothly even when
// the main thread is busy parsing/executing the just-fetched chunk.
export default function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-label="Loading">
      <span className="route-spinner" />
    </div>
  );
}
